import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import { E_Route } from "../../models/constants/Enum_Routes";
import ButtonsConstructor from "../shared/Input/Button/ButtonsConstructor";
import Fa from "../shared/Fa";

class Header extends Component {
	render({className, style}) {
		return (
			<header className={combineClasses("header", className)} style={style}>
				<a className={"logo"} onClick={() => window.location.reload(true)}>
					<Fa icon={"cubesave-logo-vertical"}/>
				</a>

				<nav className={"action-buttons"}>
					<ButtonsConstructor buttons={[
						{
							icon: "home",
							href: E_Route.BASE,
							routeBlacklist: [E_Route.BASE],
						}
					]}/>
				</nav>
			</header>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,
		}
	}
}

export default Header;
